import React, { useEffect, useState } from 'react';
import Hero4 from '../Hero/Hero4';
import { pageTitle } from '../../helper';
import Div from '../Div';
import FunFact2 from '../FunFact/FunFact2';
import Spacing from '../Spacing';
import SectionHeading from '../SectionHeading';
import MovingText2 from '../MovingText/MovingText2';
import VideoModal from '../VideoModal';
import Portfolio from '../Portfolio';
import Cta from '../Cta';
import LogoList from '../LogoList';

// const heroSocialLinks = [
//   {
//     name: 'Behance',
//     links: '/',
//   },
//   {
//     name: 'Twitter',
//     links: '/',
//   },
// ];
// const funfaceData = [
//   {
//     title: 'Digital products',
//     factNumber: '56',
//   },
//   {
//     title: 'Global happy clients',
//     factNumber: '50',
//   },
//   {
//     title: 'Project completed',
//     factNumber: '70',
//   }
// ];
const serviceData1 = [
  {
    title: 'UI/UX Design',
    href: '/service/service-details',
  },
  {
    title: 'AI',
    href: '/service/service-details',
  },
  {
    title: 'Marketing',
    href: '/service/service-details',
  },
  {
    title: 'Branding',
    href: '/service/service-details',
  },

];
const serviceData2 = [
  {
    title: 'SEO',
    href: '/service/service-details',
  },
  {
    title: 'App design',
    href: '/service/service-details',
  },
  {
    title: 'React Developer',
    href: '/service/service-details',
  },
];
const portfolioData = [
  {
    title: 'Become Rooted',
    subtitle: 'See Details',
    href: 'https://becomerooted.eu/',
    src: '/images/portfolio/becomerooted.png',
    category: 'ui_ux_design',
  },
  {
    title: 'Bella-Vista Opticien',
    subtitle: 'See Details',
    href: 'https://bellavista-opticien.nl/',
    src: '/images/portfolio/bellavista.png',
    category: 'logo_design',
  },
  {
    title: 'Praeventor',
    subtitle: 'See Details',
    href: 'https://praeventor.nl/',
    src: '/images/portfolio/praeventor.png',
    category: 'web_design',
  },
  {
    title: 'Regel Je Lease',
    subtitle: 'See Details',
    href: 'https://regeljelease.nl/',
    src: '/images/portfolio/regeljelease.png',
    category: 'ui_ux_design',
  },
];

export default function DigitalAgencyHome() {
  // eslint-disable-next-line no-unused-vars
  const [itemShow, setItemShow] = useState(6);
  pageTitle('Home');
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      {/* Start Hero Section */}
      <Hero4
        title="We Are <span>A</span>CE <br />"
        subtitle="We streamline workflows with AI to create websites that drive leads and earn top reviews, letting you focus on what you do best."
        scrollDownId="#service"
        socialLinksHeading="Follow Us"
        // heroSocialLinks={heroSocialLinks}
        phoneNumber="+31 6 27468033"
        email="info@aceautomation.nl"
      />
      {/* End Hero Section */}

      {/* Start Funfact Section */}
      {/*<Div className="container">*/}
      {/*  <FunFact2*/}
      {/*    data={funfaceData}*/}
      {/*    variant="cs-type1"*/}
      {/*    bgUrl="/images/funfact_shape_bg.svg"*/}
      {/*  />*/}
      {/*</Div>*/}
      {/* End Funfact Section */}

      {/* Start Services Section */}
      <Spacing lg="145" md="80" />
      <Div className="container">
        <SectionHeading
          title="What we provide"
          subtitle="Services"
          variant="cs-style1 text-center"
        />
        <Spacing lg="65" md="45" />
      </Div>
      {/* End Services Section */}

      {/* Start Moving Text Section */}
      <MovingText2 data={serviceData1} />
      <Spacing lg="20" md="10" />
      <MovingText2 reverseDirection data={serviceData2} />
      {/* End Moving Text Section */}

      {/* Start About Section */}
      <Div className="cs-shape_wrap_4">
        <Div className="cs-shape_4"></Div>
        <Div className="cs-shape_4"></Div>
        <Spacing lg="150" md="80" />
        <Div className="container">
          <Div className="row">
            <Div className="col-lg-5 col-xl-4">
              <SectionHeading
                title="We empower your digital business"
                subtitle="Why Choose Us"
                btnText="Learn More"
                btnLink="/about"
              />
              <Spacing lg="45" md="45" />
            </Div>
            <Div className="col-lg-7 offset-xl-1">
              <Div className="cs-half_screen">
                <VideoModal
                  videoSrc="https://www.youtube.com/watch?v=JSA2oezQWOU"
                  bgUrl="/images/video_bg.jpeg"
                  variant="cs-style1 cs-size1"
                />
              </Div>
            </Div>
          </Div>
        </Div>
      </Div>
      {/* End About Section */}

      {/* Start Projects Section */}
      <Spacing lg="145" md="80" />
      <Div className="container" style={{ paddingBottom: "200px"}}>
        <SectionHeading
          title="Portfolio to explore"
          subtitle="Latest Projects"
          variant="cs-style1 text-center"
        />
        <Spacing lg="90" md="45" />
        <Div className="row">
          {portfolioData.slice(0, itemShow).map((item, index) => (
            <Div
              className={`${
                index === 0 || index === 3 || index === 4
                  ? 'col-lg-8'
                  : 'col-lg-4'
              }`}
              key={index}
            >
              <Portfolio
                title={item.title}
                subtitle={item.subtitle}
                href={item.href}
                src={item.src}
                variant="cs-style1 cs-type1"
              />
              <Spacing lg="25" md="25" />
            </Div>
          ))}
        </Div>

        {/*<Div className="text-center">*/}
        {/*  {portfolioData.length <= itemShow ? (*/}
        {/*    ''*/}
        {/*  ) : (*/}
        {/*    <>*/}
        {/*      <Spacing lg="65" md="40" />*/}
        {/*      <span*/}
        {/*        className="cs-text_btn"*/}
        {/*        onClick={() => setItemShow(itemShow + 3)}*/}
        {/*      >*/}
        {/*        <span>Load More</span>*/}
        {/*        <Icon icon="bi:arrow-right" />*/}
        {/*      </span>*/}
        {/*    </>*/}
        {/*  )}*/}
        {/*</Div>*/}
      </Div>
      {/* End Projects Section */}

      {/* Start Awards Section */}
      {/*<Spacing lg="140" md="80" />*/}
      {/*<Div className="container">*/}
      {/*  <Div className="row">*/}
      {/*    <Div className="col-xl-4">*/}
      {/*      <SectionHeading*/}
      {/*        title="We get multiple awards"*/}
      {/*        subtitle="Our Awards"*/}
      {/*        variant="cs-style1"*/}
      {/*      />*/}
      {/*      <Spacing lg="90" md="45" />*/}
      {/*    </Div>*/}
      {/*    <Div className="col-xl-7 offset-xl-1">*/}
      {/*      <TimelineSlider />*/}
      {/*    </Div>*/}
      {/*  </Div>*/}
      {/*</Div>*/}
      {/*<Spacing lg="145" md="80" />*/}
      {/* End Awards Section */}

      {/* Start Testimonial Section */}
      {/*<TestimonialSlider />*/}
      {/* End Testimonial Section */}

      {/*/!* Start Blog Section *!/*/}
      {/*<Div className="cs-shape_wrap_4">*/}
      {/*  <Div className="cs-shape_4"></Div>*/}
      {/*  <Div className="cs-shape_4"></Div>*/}
      {/*  <Spacing lg="145" md="80" />*/}
      {/*  <Div className="container">*/}
      {/*    <Div className="row">*/}
      {/*      <Div className="col-lg-5 col-xl-4">*/}
      {/*        <SectionHeading*/}
      {/*          title="Explore recent publication"*/}
      {/*          subtitle="Our Blog"*/}
      {/*          btnText="View More Blog"*/}
      {/*          btnLink="/blog"*/}
      {/*        />*/}
      {/*        <Spacing lg="45" md="45" />*/}
      {/*      </Div>*/}
      {/*      <Div className="col-lg-7 offset-xl-1">*/}
      {/*        <PostList />*/}
      {/*      </Div>*/}
      {/*    </Div>*/}
      {/*  </Div>*/}
      {/*</Div>*/}
      {/*<Spacing lg="145" md="80" />*/}
      {/*/!* End Blog Section *!/*/}

      {/* Start LogoList Section */}
      <Div className="container" style={{ paddingTop: "100px"}}>
        <SectionHeading
          title="Our reputed partner"
          subtitle="Top Clients"
          variant="cs-style1 text-center"
        />
        <Spacing lg="90" md="45" />
        <LogoList />
      </Div>
      <Spacing lg="150" md="80" />
      {/* End LogoList Section */}

      {/* Start CTA Section */}
      <Div className="container">
        <Cta
          title="Let’s make <br />something <i>cool</i> together"
          btnText="Apply For Meeting"
          btnLink="/contact"
          bgSrc="/images/cta_bg.jpeg"
        />
      </Div>
      {/* End CTA Section */}
    </>
  );
}
